export default "__VITE_ASSET__Cjv8$y2d__"